import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface Crumb {
  label: string;
  to?: string;
}

/** phpBB3-style breadcrumb bar. */
export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="mb-4 rounded-[6px] border border-[#d6d6d6] bg-[linear-gradient(to_bottom,#f4f4f4,#e9e9e9)] px-3 py-2 text-sm text-[#5c5c5c]"
    >
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            {item.to ? (
              <Link to={item.to} className="text-[#105B86] hover:underline">
                {item.label}
              </Link>
            ) : (
              <span className="font-semibold text-[#333]">{item.label}</span>
            )}
            {i < items.length - 1 && (
              <ChevronRight className="h-3.5 w-3.5 text-[#999]" />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
